import IngredientDisplay from "@/models/Ingredient/IngredientDisplay";
import {DishRecipeCommon} from "@/models/DishRecipeCommon";
import {RecipeCompositionMeasurement} from "@/models/Recipes/RecipeCompositionMeasurement";
import {
  buildComplexIngredientName,
  getIngredientAndSubRecipeDisplays,
  getIngredientDisplays,
  getSubrecipeWeightInGrams
} from "@/services/ExportLabel.service";
import {AdditionalContent} from "@/models/NutritionLabels/AdditionalContent";

export class LabelIngredientConfiguration {
  mayContain: AdditionalContent;
  includeIngredients: boolean;
  shouldExpandSubrecipes: boolean;
  ingredientAndSubRecipeDisplaysModel : {
        combinedSubRecipeList : IngredientDisplay[];
        expandedSubRecipeList : IngredientDisplay[];
    };
  thresholdPercent: number | null;
  savedDisplays: IngredientDisplay[];
  savedSubRecipeDisplays: IngredientDisplay[];


  constructor() {
    this.mayContain = {
      primaryLanguageAdditionalContent: "",
      secondaryLanguageAdditionalContent: "",
    };
    this.thresholdPercent = 2.0;
    this.includeIngredients = true;
    this.shouldExpandSubrecipes = false;

    this.ingredientAndSubRecipeDisplaysModel = {
      combinedSubRecipeList: [],
      expandedSubRecipeList: []
    };
    this.savedDisplays = [];
    this.savedSubRecipeDisplays = [];
  };

  /**
     * Gets a formatted list of ingredient displays
     * NOTE: This is for Recipes only
     */
  getIngredientDisplays(recipe: DishRecipeCommon): IngredientDisplay[] {
    // If we're in a dish recipe, ingredients will be undefined, so we use an empty array
    return getIngredientDisplays(recipe.ingredients || [], this.savedDisplays);
  }

  /**
     * Gets a formatted list of sub-recipe displays
     * These take the format of Subrecipe (ingredient1, ingredient2, ingredient3, ...)
     */
  getSubRecipeDisplays(recipe: DishRecipeCommon, subrecipeMeasurements: RecipeCompositionMeasurement[]): IngredientDisplay[] {
    // check if there is a recipe
    // if not, will return empty aRRAY
    const displays: IngredientDisplay[] = [];

    if (recipe) {
      // map the ingredients
      recipe.childRecipes.map((recipe) => {
        // See if you can find savedDisplay in savedDisplays for the recipe Id
        const savedDisplay = this.savedSubRecipeDisplays.find(
          (x) => x.recipeId == recipe.recipe.id
        );

        const subRecipeWeight = getSubrecipeWeightInGrams(recipe, subrecipeMeasurements);

        // If found, push that one
        if (savedDisplay) {
          displays.push({
            recipeId: savedDisplay.recipeId,
            displayTextInPrimaryLanguage: savedDisplay.displayTextInPrimaryLanguage,
            displayTextInSecondaryLanguage: savedDisplay.displayTextInSecondaryLanguage,
            displayText: savedDisplay.displayText,
            isAllergen: savedDisplay.isAllergen,
            allergenVisualState: savedDisplay.allergenVisualState,
            allergenFormattingStyle: savedDisplay.allergenFormattingStyle,
            allergenFormattingColor: savedDisplay.allergenFormattingColor,
            allergenFormattingHighlightColor: savedDisplay.allergenFormattingHighlightColor,
            allergenFormattingFontFamily: savedDisplay.allergenFormattingFontFamily,
            allergenFormattingFontSize: savedDisplay.allergenFormattingFontSize,
            isBranded: false,
            weightInGrams: subRecipeWeight,
          });
        }

        else {
          let displayTextInPrimaryLanguage = buildComplexIngredientName(recipe.recipe);

          displays.push({
            recipeId: recipe.recipe.id,
            displayTextInPrimaryLanguage: displayTextInPrimaryLanguage,
            displayTextInSecondaryLanguage: "",
            isAllergen: false,
            isBranded: false,
            weightInGrams: subRecipeWeight,
          });
        }
      });
    }

    return displays;
  }

  // Merge ingredientDisplay and subRecipeDisplay
  getIngredientAndSubRecipeDisplays(
    recipe: DishRecipeCommon,
    subrecipeMeasurements: RecipeCompositionMeasurement[],
    renderExpandedSubrecipes : boolean
  ): IngredientDisplay[] {
    return getIngredientAndSubRecipeDisplays(
      this.getIngredientDisplays(recipe),
      recipe,
      this.getSubRecipeDisplays(recipe, subrecipeMeasurements),
      subrecipeMeasurements,
      renderExpandedSubrecipes
    );
  }
}